import { THEMES } from '@convenia/helpers'

export const theme = {
  props: {
    /**
     * The type of theme
     */
    theme: {
      type: [ String ],
      validator: theme => {
        return THEMES.includes(theme)
      }
    }
  }
}
